module.exports = __webpack_public_path__ + "img/11.b3ed6d2d.webp";